module.exports = __webpack_public_path__ + "assets/img/icon2.1.71bae252.svg";